import { DiscoverLayoutComponents, GridType } from 'types';

export const mapGridComponentToGridType = {
  [DiscoverLayoutComponents.ProductsEqualGrid]: GridType.Equal,
  [DiscoverLayoutComponents.ProductsUnEqualGrid]: GridType.OneLarge,
};

export const mapMixedLayoutToClassName = {
  [DiscoverLayoutComponents.MixedLayout1]: 'layout-1',
  [DiscoverLayoutComponents.MixedLayout2]: 'layout-2',
  [DiscoverLayoutComponents.MixedLayout3]: 'layout-3',
};

export const FULL_WIDTH_CAROUSEL_SLIDES = 5.2;

export const SMALL_PRODUCTS_MIXED_LAYOUT_SLIDES = 3.4;

export const BIG_PRODUCTS_MIXED_LAYOUT_SLIDES = 2;
